import { useState, useEffect } from "react";

import { Select, MenuItem, FormControl, FormHelperText, ListItemText } from "@mui/material";
import axios from "axios";
import Loader from "../../UI/Loader/Loader";
import { useTheme } from "@mui/material/styles";
import { useFilters } from "../../../Context/FiltersContext";
import { MenuProps, getStyles, Headers, useStyles } from "../Utils";
import { INVOKE_URL } from "../../../constants/api";

const TicketStatus = () => {
  const theme = useTheme();
  const { projectKey, fixVersion, issueStatus, setIssueStatus } = useFilters();

  const [selectedIssueStatus, setSelectedIssueStatus] = useState([]);
  const [loader, setLoader] = useState(true);
  const [isOpen, setIsOpen] = useState(false);

  const projectKeySS = JSON.parse(sessionStorage.getItem("projectKey"));
  const versionSS = JSON.parse(sessionStorage.getItem("fixVersion"));
  const issueStatusSS = JSON.parse(sessionStorage.getItem("issueStatus"));
  const URL = `${INVOKE_URL}/ticketstatus?projectKey=${projectKeySS}&version=${versionSS}`;

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    fetchIssueStatus(signal);

    return () => {
      controller.abort();
    };
  }, [projectKey, fixVersion]);

  const fetchIssueStatus = async (signal) => {
    // Dev Only testing
    // const res = await axios.get(
    //   `/multiSelect/ticketStatus/${projectKey}/${fixVersion}`, {signal: signal}
    // );
    try {
      if (projectKeySS?.length && versionSS?.length) {
        const res = await axios.get(URL, { Headers, signal });
        const data = res.data;
        const rmDataDuplicates = [...new Set(data)];
        setSelectedIssueStatus(rmDataDuplicates);
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const issueStatusHandler = (event) => {
    const value = event.target.value;
    const selectedAll = issueStatus.length === selectedIssueStatus.length ? [] : selectedIssueStatus;
    if (value[value.length - 1] === "all") {
      setIssueStatus(selectedAll);
      sessionStorage.setItem("issueStatus", JSON.stringify(selectedAll));
      setIsOpen(false);
      return;
    }
    sessionStorage.setItem("issueStatus", JSON.stringify(value));
    setIssueStatus(value);
    setIsOpen(false);
  };

  const isAllSelected = issueStatus.length > 0 && issueStatus.length === selectedIssueStatus.length;
  const isSelectedIssueStatus = Array.isArray(selectedIssueStatus) && selectedIssueStatus.length > 0;

  return (
    <FormControl variant="standard" sx={{ m: 1, minWidth: 300 }}>
      <Select
        label="ticket-status"
        id="ticket-status"
        multiple
        value={issueStatusSS ?? []}
        MenuProps={MenuProps}
        onChange={issueStatusHandler}
        renderValue={(selected) => selected.join(", ")}
        open={isOpen}
        onOpen={() => setIsOpen(true)}
        onClose={() => setIsOpen(false)}
      >
        {isSelectedIssueStatus ? (
          <MenuItem
            value="all"
            classes={{
              selected: isAllSelected ? useStyles.selectedAll : "",
            }}
          >
            <ListItemText classes={{ primary: useStyles.selectAllText }} primary={isAllSelected ? "Unselect All" : "Preview All"} />
          </MenuItem>
        ) : null}

        {!loader ? (
          isSelectedIssueStatus ? (
            selectedIssueStatus.map((data) => (
              <MenuItem key={data} value={data} style={getStyles(data, selectedIssueStatus, theme)}>
                {data}
              </MenuItem>
            ))
          ) : (
            <MenuItem disabled={true}>No issue status available..</MenuItem>
          )
        ) : (
          <Loader />
        )}
      </Select>
      <FormHelperText style={useStyles.formHelperText}>Choose one or multiple issue status.</FormHelperText>
    </FormControl>
  );
};

export default TicketStatus;
